export default __webpack_public_path__ + "static/media/milestone 700.7ef1b9aa.svg";